/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { Drawer, Button, Grid, Typography } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import RadioGroup from '@mui/material/RadioGroup'
import { Close, Check } from '@mui/icons-material'
import LoadingButton from '@mui/lab/LoadingButton'
import Radio from '@mui/material/Radio'
import { connect } from 'react-redux'
import * as online from '../../../../appRedux/actions/fuel_request/online'
import IntlMessages from '../../../../util/IntlMessages'
import useStyles from './end_refueling.style'

function EndRequest(props) {
    const anchor = 'bottom'
    const classes = useStyles()
    const [userCarAccuracy, setUserCarAccuracy] = useState('')

    const operatorCompleteRequestFunc = async () => {
        await props.operatorCompleteRequestAction({
            vRequestCode: props.vRequestCode,
            iPaymentType: props.iPaymentType,
            iUserCarAccuracy: userCarAccuracy
        })
        props.setEndRefueling()
    }

    return (
        <React.Fragment>
            <Drawer
                anchor={anchor}
                open={props.endRefueling}
                onClose={() => props.setEndRefueling()}
            >
                <Grid className={classes.root}>
                    <Typography className={classes.title} variant="h3">
                        <IntlMessages id="endOfRefueling" />
                    </Typography>
                    <Grid style={{ marginTop: 20, marginBottom: 20 }}>
                        <Grid style={{ display: 'flex', flexDirection: 'row' }}>
                            <Typography variant='body1'>
                                <IntlMessages id="isTheCar" />
                            </Typography>
                            <Typography variant='body1'>
                                {' ( ' + props.details.licensePlate[0].vNameCar + ' ) '}
                            </Typography>
                            <Typography variant='body1'>
                                <IntlMessages id="compatibleWithUserCar" />
                            </Typography>
                        </Grid>
                        <RadioGroup row>
                            <FormControlLabel onChange={(e) => setUserCarAccuracy(e.target.value)} value={1} control={<Radio />} label={<IntlMessages id="correspond" />} />
                            <FormControlLabel onChange={(e) => setUserCarAccuracy(e.target.value)} value={0} control={<Radio />} label={<IntlMessages id="doesNotMatch" />} />
                        </RadioGroup>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={8} md={8}>
                            <LoadingButton
                                disabled={userCarAccuracy === '' ? true : false}
                                variant='contained'
                                onClick={() => operatorCompleteRequestFunc()}
                                loading={props.loadingBtn}
                                color="secondary"
                                fullWidth
                                startIcon={<Check />}>
                                <IntlMessages id="yes" />
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <Button
                                fullWidth
                                onClick={() => props.setEndRefueling()}
                                startIcon={<Close />}>
                                <IntlMessages id="no" />
                            </Button>

                        </Grid>
                    </Grid>
                </Grid>
            </Drawer>
        </React.Fragment >
    )
}

const mapStateToProps = (state) => {
    return {
        loadingBtn: state.common.loadingBtn,
        details: state.field.requestOnline,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        operatorCompleteRequestAction: (data) =>
            dispatch(online.operatorCompleteRequestAction(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EndRequest)